// PRODUCT CONFIG (Single Source of Truth)
// Add new products ONLY here in future

const base = ["HOME", "ENROLLMENT", "SETTINGS"]; //base modules for all products
const inventory = ["INVENTORY", "ALERTS", "REPORTS"]; //inventory related modules
const vulnerability = ["PATCH", "REPORTS"]; //vulnerability related modules
export let PRODUCT_CONFIG = {
  ra: {
    id: "2",
    name: "Remote Access",
    route: "/ra",
    routeGroups: [...base, "REMOTE"],
  },
  em: {
    id: "5",
    name: "Endpoint Manager",
    route: "/em",
    routeGroups: [...base, ...inventory, "REMOTE", "MANAGE", "PATCH"],
  },
  am: {
    id: "4",
    name: "Asset Manager",
    route: "/am",
    routeGroups: [...base, ...inventory],
  },
  vm: {
    id: "7",
    name: "Vulnerability Manager",
    route: "/vm",
    routeGroups: [...base, ...vulnerability],
  },
  pm: {
    id: "8",
    name: "Patch Manager",
    route: "/pm",
    routeGroups: [...base, ...vulnerability],
  },
  "em-msp": {
    id: "6",
    name: "Endpoint Manager MSP",
    route: "/em-msp",
    routeGroups: [...base, ...inventory, "REMOTE", "MANAGE", "PATCH"],
  },
};

export const MSP_MAP = {
  em: "em-msp",
  ra: "ra-msp",
  am: "am-msp",
};

export const enterpriseProducts = Object.keys(PRODUCT_CONFIG).filter(
  (key) => !key.includes("msp"),
);
export const mspProducts = Object.keys(PRODUCT_CONFIG).filter((key) =>
  key.includes("msp"),
);

export const normalizeMSPProductKeys = (keys = []) => {
  const set = new Set(keys);
  keys.forEach((key) => {
    if (!key.endsWith("-msp")) set.add(`${key}-msp`);
  });
  return [...set];
};

//priority order for product selection if no product in URL: EM > VM > AM > RA
//Note: This logic is only for the default route ("/") when no product is specified in the URL. If a user tries to access a specific product route directly, it will not override their choice and will load that product instead. if the prority needs to be changed in the future, simply change the order of the products in the PRODUCT_PRIORITY array.
export const PRODUCT_PRIORITY = ["em-msp", "em", "vm", "am", "ra", "pm"];

export const removeModuleFromProduct = (module, product) => {
  if (PRODUCT_CONFIG[product])
    PRODUCT_CONFIG[product].routeGroups = PRODUCT_CONFIG[
      product
    ].routeGroups.filter((m) => m !== module);
};
removeModuleFromProduct("HOME", "ra");

export const getProductsByRouteGroup = (groupName) => {
  const result = Object.entries(PRODUCT_CONFIG)
    .filter(([, config]) => (config.routeGroups || []).includes(groupName))
    .map(([productKey]) => productKey);
  return result;
};

export const Products = Object.fromEntries(
  Object.entries(PRODUCT_CONFIG).map(([key, value]) => [key, value.name]),
);
